import { render, staticRenderFns } from "./bookmarks.vue?vue&type=template&id=c73a8df4&"
import script from "./bookmarks.vue?vue&type=script&lang=js&"
export * from "./bookmarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports